
import NfceCancelamentoService from "../services/NfceCancelamentoService";

export default {
  name: "CancelarNfceModal",

  props: {
    nfce: { type: Object, required: true },
  },

  data() {
    return {
      justificativa: "",
      enviando:      false,
      erro:          null,
      JUSTIFICATIVA_MIN: NfceCancelamentoService.JUSTIFICATIVA_MIN,
      JUSTIFICATIVA_MAX: NfceCancelamentoService.JUSTIFICATIVA_MAX,
    };
  },

  computed: {
    caracteresInsuficientes() {
      return this.justificativa.trim().length > 0
          && this.justificativa.trim().length < this.JUSTIFICATIVA_MIN;
    },
    podeEnviar() {
      const len = this.justificativa.trim().length;
      return len >= this.JUSTIFICATIVA_MIN && len <= this.JUSTIFICATIVA_MAX;
    },
  },

  methods: {
    fechar() {
      if (this.enviando) return;
      this.$emit("fechar");
    },

    async confirmar() {
      if (!this.podeEnviar || this.enviando) return;
      this.erro     = null;
      this.enviando = true;
      try {
        const resultado = await NfceCancelamentoService.cancelarNfce(
          this.nfce.uuid_venda_terminal,
          this.justificativa.trim(),
        );
        if (resultado.success) {
          this.$emit("cancelado", resultado);
        } else {
          this.erro = resultado.motivo || "Cancelamento recusado pela SEFAZ.";
        }
      } catch (e) {
        this.erro = e.message || String(e);
      } finally {
        this.enviando = false;
      }
    },
  },
};
